module.exports = {
    xs: 0,
    sm: '576px',
    md: '768px',
    lg: '992px',
    xlg: '1024px',
    xl: '1200px',
    xxl: '1440px',
};
